import { Checkbox, Progress, Tag } from "antd";
import { E_PROMOTION_CODE_TYPE } from "constants/promotionCode";
import { Ticket } from "lucide-react";
import { FC, useState } from "react";
import { IPromotionCode } from "types/promotionCode";
import { formatDateTime } from "utils/datetime";
import { calculatePercent } from "utils/promotionCode";
import PromotionCodeDetailModal from "./PromotionCodeDetailModal";

interface IPromotionCodeItem {
  data: IPromotionCode;
  isSelected?: boolean;
  isDisabled?: boolean;
  onSelect: (selected: boolean, code: string) => void;
  productIds?: number[];
  isProductSpecificDisabled?: boolean;
}
const PromotionCodeItem: FC<IPromotionCodeItem> = ({
  data,
  isSelected = false,
  onSelect,
  isDisabled,
  productIds = [],
  isProductSpecificDisabled = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Check if this is a product-specific promotion and if it's applicable
  const isProductSpecific = data.products && data.products.length > 0;
  const applicableProductIds = data.products
    ? data.products.map((p) => p.id)
    : [];
  const hasApplicableProducts =
    !isProductSpecific ||
    applicableProductIds.some((id) => productIds.includes(id));

  // Final disabled state combines original disabled state and product-specific logic
  const finalIsDisabled =
    isDisabled ||
    isProductSpecificDisabled ||
    (isProductSpecific && !hasApplicableProducts);

  const handleConditionsClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the promotion item click event
    setIsModalOpen(true);
  };

  return (
    <>
      <div
        className={`flex justify-between items-center border-1 p-4 cursor-pointer rounded-sm ${
          isSelected ? "border-primary bg-primary-50" : "border-[#E0E0E0]"
        } ${finalIsDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
        onClick={() => {
          if (!finalIsDisabled) {
            onSelect(isSelected, data.code);
          }
        }}
      >
        <div className={`flex gap-4 items-center w-full`}>
          <div className="bg-[#F8F8F9]">
            <Ticket color={`${isSelected ? "#9448ff" : "black"}`} />
          </div>
          <div className="w-full">
            <div className="flex items-center gap-2 mb-1">
              <div className="font-semibold">
                ลด {data.value}
                {data.type === E_PROMOTION_CODE_TYPE.PERCENTAGE ? "%" : "บาท"}
              </div>
              {isProductSpecific && (
                <Tag color={hasApplicableProducts ? "green" : "red"}>
                  <small>
                    {hasApplicableProducts
                      ? "ใช้ได้กับสินค้าในตะกร้า"
                      : "ไม่ใช่สินค้าที่กำหนด"}
                  </small>
                </Tag>
              )}
              {!isProductSpecific && (
                <Tag color="blue">
                  <small>ใช้ได้กับทุกสินค้า</small>
                </Tag>
              )}
            </div>
            <p>
              <small>
                รับส่วนลด {data.value}
                {data.type === E_PROMOTION_CODE_TYPE.PERCENTAGE
                  ? "%"
                  : "บาท"}{" "}
                {data.type === E_PROMOTION_CODE_TYPE.PERCENTAGE &&
                data.maxDiscountAmount != null &&
                +data.maxDiscountAmount < 100000
                  ? `สูงสุด ${(+data.maxDiscountAmount).toLocaleString()} `
                  : " "}
                {data.minOrderAmount
                  ? `เมื่อซื้อขั้นต่ำ ${(+data.minOrderAmount).toLocaleString()} บาท`
                  : `ไม่มีขั้นต่ำ`}
              </small>
            </p>
            {/* {isProductSpecific && !hasApplicableProducts && (
            <p>
              <small className="text-red-500">
                โค้ดนี้ใช้ได้เฉพาะกับสินค้าที่กำหนดเท่านั้น
                กรุณาเพิ่มสินค้าที่เข้าร่วมโปรโมชั่นในตะกร้า
              </small>
            </p>
          )} */}

            <Progress
              size="small"
              percent={calculatePercent(
                data._count.usageHistory,
                data.maxUsageLimit
              )}
              showInfo={false}
              strokeColor="#9448ff"
            />
            <p>
              <small>
                ใช้แล้ว{` `}
                {calculatePercent(data._count.usageHistory, data.maxUsageLimit)}
                % {` `}
              </small>
              <small>
                {data.endDate
                  ? `ใช้ได้ถึง ${formatDateTime(data.endDate, true)}`
                  : ``}
              </small>
              <small
                className="text-blue-600 cursor-pointer hover:text-blue-800 underline ml-2"
                onClick={handleConditionsClick}
              >
                รายละเอียด
              </small>
            </p>
          </div>
        </div>
        <div>
          <Checkbox checked={isSelected} disabled={finalIsDisabled} />
        </div>
      </div>

      <PromotionCodeDetailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        promotionCode={data}
      />
    </>
  );
};
export default PromotionCodeItem;
